import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
// Self-hosted brand fonts (no CDN on a private site).
import "@fontsource/m-plus-1/400.css";
import "@fontsource/m-plus-1/500.css";
import "@fontsource/m-plus-1/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/700.css";
import "./styles/global.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error('Root element "#root" not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
